export function isMobile(maxWidth = '760px') {
  try {
    return window.matchMedia(`only screen and (max-width: ${maxWidth})`).matches;
  } catch (e) {
    return false;
  }
}
